import axios from "axios";
import { refreshSessionOrLogout } from "./interceptors";
import { commonHeaders } from "./commonHeader";
import TokenService from "./tokenManager";
import { API_BASE_URL } from "config";

const loanClient = axios.create({
  baseURL: API_BASE_URL,
  headers: commonHeaders,
  withCredentials: false,
});

loanClient.interceptors.request.use(
  (config) => {
    const token = TokenService.getLocalAccessToken();    
    if (token) {
      if (config.headers) config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

loanClient.interceptors.response.use((res) => {
  return res;
}, refreshSessionOrLogout());

export default loanClient;
